const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  }

  return (
    <span className={`inline-flex items-center justify-center ${className}`}>
      <span className={`${sizeClasses[size]} inline-block animate-spin rounded-full border-2 border-gray-300 border-t-blue-600`} />
    </span>
  )
}

export default LoadingSpinner
